angular.module('controllers').controller('shippingMethodController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$route', '$routeParams', '$location', '$timeout',
    function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $route, $routeParams, $location, $timeout) {
        $rootScope.path = '/shipping-method';
        $scope.path = $rootScope.path;
        $rootScope.modelName = 'shipping-method';
        $scope.pathTemplate = 'clients/shippingmethods';
        $scope.title = 'Metode de livrare';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.sortType = 'shipping_method_name';
        $scope.defaultItem = 10;
        $rootScope.typeId = 'id';
        $scope.search.order = 'asc';
        $scope.classAction = 'td-big';
        $scope.columns = {
            //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
            'shipping_method_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
            'shipping_method_price':{'label':'Cost', 'filter':1, 'filterType':'input'},
            'shipping_method_percent':{'label':'Procent', 'filter':1, 'filterType':'input'},
            'status':{'label':'Status', 'filter':1, 'filterType':'select'}
        };

        $scope.columns.status.options = [
            {'id':'', 'value' : ''},
            {'id':1, 'value' : 'true'},
            {'id':0, 'value' : 'false'}
        ];

        $scope.additionals = [];
        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'shipping_method_name';

        /* get dependent fields */
        $scope.getDependedFields = function () {
            Crud.getDependedFields($scope.path)
                .success(function (data) {
                    $scope.additionals['localities'] = data.localities;
                });

            $scope.additionals['signs'] = [
                {'id':'=', 'value' : '='},
                {'id':'>', 'value' : '>'},
                {'id':'>=', 'value' : '>='},
                {'id':'<', 'value' : '<'},
                {'id':'<=', 'value' : '<='}
            ];
        }

        $scope.additionals['functionResult']= function(ev, data) {
            if (!angular.isUndefined($scope.modelData.shipping_method_name)) {
                $scope.modelData.shipping_method_name = $scope.modelData.shipping_method_name.toLowerCase();
            }
            if (!angular.isUndefined($scope.modelsData)) {
                angular.forEach($scope.modelsData, function (item, key) {
                    if (!angular.isUndefined($scope.modelsData[key].shipping_method_name)) {
                        $scope.modelsData[key].shipping_method_name = $scope.modelsData[key].shipping_method_name.toLowerCase();
                    }
                });
            }
        }

        $scope.additionals['searchTerm'];
        $scope.additionals['clearSearchTerm'] = function() {
            $scope.additionals['searchTerm'] = '';
        };
        $scope.additionals['onSearchChange'] = function(ev) {
            ev.stopPropagation();
        };

        /* add multiple ingredient forms */
        $scope.additionals['rules'] = [{}];
        $scope.additionals['cloneItem'] = function (model, modelLength) {
            var itemToClone = {};
            $scope.additionals[model].push(itemToClone);
        }

        $scope.additionals['removeItem']= function (itemIndex, modelRule) {
            if(!angular.isUndefined($scope.errors) ) {
                if(!angular.isUndefined($scope.errors['rules.' + itemIndex + '.locality_ids']) ) {
                    delete $scope.errors['rules.' + itemIndex + '.locality_ids'];
                }
                if(!angular.isUndefined($scope.errors['rules.' + itemIndex + '.section_ids']) ) {
                    delete $scope.errors['rules.' + itemIndex + '.section_ids'];
                }
                if(!angular.isUndefined($scope.errors['rules.' + itemIndex + '.order_value']) ) {
                    delete $scope.errors['rules.'+itemIndex+'.order_value'];
                }
                if(!angular.isUndefined($scope.errors['rules.' + itemIndex + '.rule_sign']) ) {
                    delete $scope.errors['rules.'+itemIndex+'.rule_sign'];
                }
                if(!angular.isUndefined($scope.errors['rules.' + itemIndex + '.rule_value']) ) {
                    delete $scope.errors['rules.'+itemIndex+'.rule_value'];
                }
            }

            $scope.interm = [];
            angular.forEach($scope.additionals[modelRule], function (itemy, indexy) {
                $scope.interm[indexy] = {
                    'locality_ids' : itemy['locality_ids'],
                    'section_ids' : itemy['section_ids'],
                    'order_value' : itemy['order_value'],
                    'rule_sign' : itemy['rule_sign'],
                    'rule_value' : itemy['rule_value']
                };
            });
            $scope.interms = [];
            angular.forEach($scope.interm, function (itemyy, indexyy) {
                $scope.interms.push({
                    'locality_ids' : itemyy['locality_ids'],
                    'section_ids' : itemyy['section_ids'],
                    'order_value' : itemyy['order_value'],
                    'rule_sign' : itemyy['rule_sign'],
                    'rule_value' : itemyy['rule_value']
                });
            });
            $scope.interms.splice(itemIndex, 1);
            $scope.additionals[modelRule] = $scope.interms;

            $timeout(function() {
                $scope.modelData.rules = $scope.additionals[modelRule];
            }, 100);

        }

        /* close field */
        $scope.additionals['closeField'] = function (paramName, model, keyRule, key) {
            if (!angular.isUndefined(key)) {
                model[key][paramName] = '';
            } else {
                model.rules[keyRule][paramName] = '';
            }
        }

        /* assign model */
        $scope.ruleModel = function (ev, path, model) {

            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'rule';
                $scope.errors = {};
                $scope.additionals['invalid'] = '';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");

                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    switch (key) {
                        case 'rules':
                            currentModel['rules'] = [];
                            angular.forEach(item, function (itemRules, keyRules) {
                                currentModel['rules'][keyRules] = {};
                                angular.forEach(itemRules, function (itemRulesDetail, keyRulesDetail) {
                                    currentModel['rules'][keyRules][keyRulesDetail] = itemRulesDetail;
                                });
                                currentModel['rules'][keyRules]['section_ids'] = angular.extend([], itemRules['section_ids']);
                            });
                            break;
                        default:
                            currentModel[key] = item;
                            break;
                    }
                });

                $scope.modelData = currentModel;
                if(angular.isUndefined(currentModel.rules) || currentModel.rules.length == 0) {
                    currentModel.rules = [{}];
                }
                $scope.additionals['rules'] = currentModel.rules;

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                $scope.rule = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;
                    angular.forEach($scope.modelData.rules, function (itemRule, keyRule) {
                        angular.forEach(itemRule['section_ids'], function (itemSection, keySection) {
                            if(itemRule['locality_ids'].indexOf(keySection)< 0) {
                                delete $scope.modelData.rules[keyRule].section_ids[keySection];
                            }
                        });
                    });
                    $scope.modelData['route'] = 'rule';
                    Crud.post($scope.additionals['content_type'], $scope.modelData, path + '/rule')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                                if (!angular.isUndefined(data.currentModel)) {
                                    if (!angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, data.currentModel);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = data.currentModel;
                                    }
                                } else {
                                    if (!angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, currentModel);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = currentModel;
                                    }
                                }
                            }
                            $scope.errors = {};
                            $scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                        });

                };
            }
            if($scope.mode_action == 'dialog') {
                $scope.additionals['invalid'] = '';
                $scope.errors = {};
                $scope.action = 'rule';

                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    switch (key) {
                        case 'rules':
                            currentModel['rules'] = [];
                            angular.forEach(item, function (itemRules, keyRules) {
                                currentModel['rules'][keyRules] = {};
                                angular.forEach(itemRules, function (itemRulesDetail, keyRulesDetail) {
                                    currentModel['rules'][keyRules][keyRulesDetail] = itemRulesDetail;
                                });
                                currentModel['rules'][keyRules]['section_ids'] = angular.extend([], itemRules['section_ids']);
                            });
                            break;
                        default:
                            currentModel[key] = item;
                            break;
                    }
                });
                $scope.modelData = currentModel;
                if(angular.isUndefined(currentModel.rules) || currentModel.rules.length == 0) {
                    currentModel.rules = [{}];
                }
                $scope.additionals['rules'] = currentModel.rules;

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'ruleDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        model: $scope.modelData,
                        selected: $scope.selected,
                        additionals: $scope.additionals,
                        action: $scope.action
                    }
                }).then(function () {
                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                        if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = $scope.additionals['dataCurrentModel'];
                            }
                        } else {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = currentModel;
                            }
                        }

                    }
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'selected', 'additionals', 'action'];
                function DialogController($scope, $mdDialog, pathTemplate, model, selected, additionals, action) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelData = model;
                    $scope.additionals = additionals;
                    $scope.selected = selected;
                    $scope.action = action;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.rule = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.isLoading = true;
                        angular.forEach($scope.modelData.rules, function (itemRule, keyRule) {
                            angular.forEach(itemRule['section_ids'], function (itemSection, keySection) {
                                if(itemRule['locality_ids'].indexOf(keySection)< 0) {
                                    delete $scope.modelData.rules[keyRule].section_ids[keySection];
                                }
                            });
                        });
                        $scope.modelData['route'] = 'rule';
                        Crud.post($scope.additionals['content_type'], $scope.modelData, path + '/rule')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined(data.currentModel)) {
                                        $scope.additionals['dataCurrentModel'] = data.currentModel;
                                    }
                                }
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                            });

                    };
                }
            }

        };

        $scope.additionals['selectLocality']  = function (index, model) {

            if (angular.isUndefined(model.rules[index].section_ids)) {
                model.rules[index].section_ids = [];
            }
            if (angular.isUndefined($scope.additionals['sec'])) {
                $scope.additionals['sec'] = [];
            }
            $scope.additionals['sec'][index] = [];
            for (var i = 0; i < model.rules[index]['locality_ids'].length; i++) {
                $scope.additionals['sec'][index][i] = i;
            }

            if (angular.isUndefined($scope.additionals['section'])) {
                $scope.additionals['section'] = [];
            }
            if (angular.isUndefined($scope.additionals['section'][index])) {
                $scope.additionals['section'][index] = [];
            }

            angular.forEach(model.rules[index]['locality_ids'], function (item, key) {

                var position = $scope.additionals['localities'].map(function (e) {
                    return e['id'];
                }).indexOf(item);
                if (!angular.isUndefined($scope.additionals['localities'][position])) {
                    if (!angular.isUndefined($scope.additionals['localities'][position]['section'])) {
                        $scope.additionals['section'][index][key] = $scope.additionals['localities'][position]['section'];
                        $scope.additionals['section'][index][key]['loc_name'] = $scope.additionals['localities'][position]['locality_name'];
                        $scope.additionals['section'][index][key]['loc_id'] = item;
                    } else {
                        $scope.additionals['section'][index][key] = [];
                    }
                }
            });

            /*  angular.forEach(model.rules[index]['section_ids'], function (itemSection, keySection) {
                  if(model.rules[index]['locality_ids'].indexOf(keySection)< 0) {
                      delete model.rules[index].section_ids[keySection];
                  }
              })*/
        };

        $scope.dataSelect = {};
        $scope.selectAllEntitiesLocalities = function (keyRule, model, additionalsModels) {
            if(angular.isUndefined($scope.dataSelect.select_all_entities_localities) || $scope.dataSelect.select_all_entities_localities == false) {
                $scope.modelData.rules[keyRule].locality_ids = [];
            }
            if($scope.modelData.rules[keyRule].locality_ids.length > 0) {
                $scope.modelData.rules[keyRule].locality_ids = [];
            } else {
                $scope.modelData.rules[keyRule].locality_ids = additionalsModels.map(a => a.id);
            }
            $scope.additionals['selectLocality'](keyRule, model);
        }

        $scope.selectAllEntitiesSections = function (keyRule, additionalsModels) {
            if(angular.isUndefined($scope.dataSelect.select_all_entities_sections) || $scope.dataSelect.select_all_entities_sections == false) {
                $scope.modelData.rules[keyRule].section_ids[additionalsModels['loc_id']] = [];
            }
            if(!angular.isUndefined($scope.modelData.rules[keyRule].section_ids[additionalsModels['loc_id']])) {
                if ($scope.modelData.rules[keyRule].section_ids[additionalsModels['loc_id']].length > 0) {
                    $scope.modelData.rules[keyRule].section_ids[additionalsModels['loc_id']] = [];
                } else {
                    $scope.modelData.rules[keyRule].section_ids[additionalsModels['loc_id']] = additionalsModels.map(a => a.id);
                }
            }

        }

    }]
);
